/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

/**
 * Only the fields sent change; an explicit null clears ``email`` / ``linkedin_url``.
 */
export interface UpdateNetworkMemberRequest {
  name?: string | null;
  email?: string | null;
  linkedin_url?: string | null;
}
